import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, Ref } from 'vue';

/* eslint-disable  @typescript-eslint/no-unused-vars */

import { ref, computed } from 'vue';

import * as WorkflowNodeService from '@/utils/workflow-node-service';

import SubflowSelectStartSvg from './assets/SubflowSelectStartSvg.vue';
import SubflowSelectionEndSvg from './assets/SubflowSelectionEndSvg.vue';
import SubflowSelectionEndSelectedSvg from './assets/SubflowSelectionEndSelectedSvg.vue';
import SubflowSuccessSvg from './assets/SubflowSuccessSvg.vue';
import SubflowSuccessSelectedSvg from './assets/SubflowSuccessSelectedSvg.vue';
import SubflowWarningSvg from './assets/SubflowWarningSvg.vue';

import { useSelectionIcon } from './SubflowSelectionIcon.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubflowSelectionIcon',
  props: {
	blockData: Object,
},
  setup(__props) {

const props = __props



const { isSelectingWorkflowRoute, rootNodeOfRouteSelection, lastNodeOfRouteSelection, isInSelectedWorkflowRoute, isRouteSelected } =
	useSelectionIcon();

const blockId: Ref<number> = ref<number>(props.blockData?.id);

const isBeingConvertedToSubflow: ComputedRef<boolean> = computed<boolean>(() => {
	const nodeId: string = String(blockId.value);
	if (isSelectingWorkflowRoute.value && nodeId) {
		return isInSelectedWorkflowRoute.value(nodeId);
	}
	return false;
});

const isTestedSuccessfully: ComputedRef<boolean> = computed<boolean>(
	() => WorkflowNodeService.isTestedSuccessfully(props.blockData) || WorkflowNodeService.isTestedSkipped(props.blockData)
);

const isSelectionEnd: ComputedRef<boolean> = computed<boolean>(() => {
	if (isSelectingWorkflowRoute.value) {
		return lastNodeOfRouteSelection.value === blockId.value;
	}
	return false;
});

const isInTheMiddleOfRoute: ComputedRef<boolean> = computed<boolean>(() => !isSelectionEnd.value && isBeingConvertedToSubflow.value);

return { __sfc: true,props, isSelectingWorkflowRoute, rootNodeOfRouteSelection, lastNodeOfRouteSelection, isInSelectedWorkflowRoute, isRouteSelected, blockId, isBeingConvertedToSubflow, isTestedSuccessfully, isSelectionEnd, isInTheMiddleOfRoute, SubflowSelectStartSvg, SubflowSelectionEndSvg, SubflowSelectionEndSelectedSvg, SubflowSuccessSvg, SubflowSuccessSelectedSvg, SubflowWarningSvg }
}

})